"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../../shared/components/icons/FontAwesome");
var LocaleTPLEditWagerDescription_1 = require("./LocaleTPLEditWagerDescription");
var LocaleTPLViewRendered_1 = require("./LocaleTPLViewRendered");
var LocaleTPLEditWagerCondition_1 = require("./LocaleTPLEditWagerCondition");
var LocaleTPLEditWagerTeaser_1 = require("./LocaleTPLEditWagerTeaser");
var BonusTPLLocaleOperations = /** @class */ (function (_super) {
    __extends(BonusTPLLocaleOperations, _super);
    function BonusTPLLocaleOperations(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_wager_description = "tab.wager.description";
        _this.tab_wager_teaser = "tab.wager.teaser";
        _this.tab_wager_condition = "tab.wager.condition";
        _this.tab_test = "tab.test";
        return _this;
    }
    BonusTPLLocaleOperations.prototype.componentWillMount = function () {
        this.props.state.setExtBreadCrumbPath(["Шаблоны локализации бонуса"]);
    };
    BonusTPLLocaleOperations.prototype.backToRootClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTPLLocaleOperations.prototype.getTestJSONViewObject = function () {
        return (React.createElement(LocaleTPLViewRendered_1.default, { data: this.props.data, record: this.props.record, state: this.props.state, onGoBack: this.backToRootClick.bind(this), dialogViewText: this.props.dialogViewText }));
    };
    BonusTPLLocaleOperations.prototype.getWagetTeaserTab = function () {
        //Вейджер:Тизер
        return (React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "comment-alt" }),
                "\u0422\u0438\u0437\u0435\u0440"), key: this.tab_wager_teaser },
            React.createElement(LocaleTPLEditWagerTeaser_1.default, { data: this.props.data, record: this.props.record, state: this.props.state, onGoBack: this.backToRootClick.bind(this), dialogViewText: this.props.dialogViewText })));
    };
    BonusTPLLocaleOperations.prototype.GetWagerDescriptionTab = function () {
        //Вейджер:Описание
        return (React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "comment-dots" }),
                "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"), key: this.tab_wager_description },
            React.createElement(LocaleTPLEditWagerDescription_1.default, { data: this.props.data, record: this.props.record, state: this.props.state, onGoBack: this.backToRootClick.bind(this), dialogViewText: this.props.dialogViewText })));
    };
    BonusTPLLocaleOperations.prototype.getWagerConditionTab = function () {
        //Вейджер:Отыгрыш
        return (React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "comment-dollar" }),
                "\u041E\u0442\u044B\u0433\u0440\u044B\u0448"), key: this.tab_wager_condition },
            React.createElement(LocaleTPLEditWagerCondition_1.default, { data: this.props.data, record: this.props.record, state: this.props.state, onGoBack: this.backToRootClick.bind(this), dialogViewText: this.props.dialogViewText })));
    };
    BonusTPLLocaleOperations.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_wager_teaser },
                this.getWagetTeaserTab(),
                this.GetWagerDescriptionTab(),
                this.getWagerConditionTab(),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "check-circle" }),
                        "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430"), key: this.tab_test }, this.getTestJSONViewObject()))));
    };
    return BonusTPLLocaleOperations;
}(React.Component));
exports.default = BonusTPLLocaleOperations;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ui/component/locales/LocaleTPLOperations.tsx
// module id = 1907
// module chunks = 0